export default "__VITE_ASSET__A1Hvyoyy__"